import Vue from 'vue';
import Vuex from 'vuex';
import phonetic from './phonetic';
import sidebar from './sidebar';
import app from './app';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app: app,
        phonetic: phonetic,
        sidebar: sidebar
    },
    getters: {
        phoneticVersion: state => state.phonetic.version,
        phoneticInput: state => state.phonetic.inputs[state.phonetic.version],
        phoneticOutput: state => state.phonetic.outputs[state.phonetic.version],
        pageTitle: state => state.app.pageTitle
    }
});

export default store;
